import React, { useReducer, useMemo } from 'react';
import {
  DynamicQuestionsContext,
  provider,
  initialState,
} from 'chameleon/packages/blue-book-player/state/DynamicQuestionContext';

const withDynamicQuestionsContext = (WrapperComponent) => {
  const ContextProvider = (props) => {
    const [state, dispatch] = useReducer(provider, initialState);
    const store = useMemo(() => ({ state, dispatch }), [state]);

    return (
      <DynamicQuestionsContext.Provider value={store}>
        <WrapperComponent {...props} />
      </DynamicQuestionsContext.Provider>
    );
  };

  return ContextProvider;
};

export default withDynamicQuestionsContext;
